

























import { PageMode } from '@/main/utils/pageMode';
import { editFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';

import { store } from './store/edit';
import { AKCNI_PRODEJ_ND_POLOZKY, NAME } from './constants';

export default editFactory(NAME, store).extend({
	data() {
		return {
			dependencies: { AKCNI_PRODEJ_ND_POLOZKY },
		};
	},
	methods: {
		polozkaCreate(respId: string | number) {
			openEdit(AKCNI_PRODEJ_ND_POLOZKY, PageMode.CREATE, { filter: { NdakceId: respId, SkladOzn: this.SkladOzn } });
		},
		async createAkcniProdejNdClick() {
			const id = this.isCreateMode ? await this.changeToEdit() : this.entityId!;

			this.polozkaCreate(id);
		},
		polozkyRowButtonClick({ data, mode }: { data: Record<string, any>; mode: PageMode }) {
			this.openPolozky({ ndAkceId: undefined, data, mode });
		},
		openPolozky({ ndAkceId, data, mode }: { ndAkceId: number | undefined; data: Record<string, any>; mode: PageMode }) {
			openEdit(AKCNI_PRODEJ_ND_POLOZKY, mode, { id: data?.ID, filter: { ndAkceId, skladOzn: this.SkladOzn, text: data?.TEXT } });
		},
	},
});
